import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

process.env.NODE_ENV === "production" && (console.log = () => {});
const link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");
if (link) link.href = `/logo/${process.env.REACT_APP_ENV}/favicon.ico`;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
